/*
 * Pipeline Theme – Custom JavaScript (custom.js)
 * -------------------------------------------------------------------------
 * Adds AJAX pagination (Load‑More button), hides sold‑out products until the
 * final page, and keeps in‑stock items sorted first.
 *
 * v3 – fixes lazy‑loading images that still have the `loading‑shimmer` overlay
 *      after being re‑inserted by the `theme:grid:updated` listener.
 * -------------------------------------------------------------------------
 */

;(function () {
  "use strict";

  /* =====================================================================
   * 1.  CORE THEME LISTENERS (unchanged)
   * ===================================================================*/
  document.addEventListener("theme:variant:change", (e) => {
    /* your variant‑change logic here */
  });
  document.addEventListener("theme:cart:change", (e) => {
    /* your cart‑change logic here */
  });
  document.addEventListener("theme:cart:init", () => {
    /* fires on initial page load */
  });

  /* =====================================================================
   * 2.  SORT sold‑out BELOW available items
   * ===================================================================*/
  function sortSoldOut() {
    const grid = document.querySelector(".collection__content .js-grid");
    if (!grid) return;
    const available = [];
    const soldOut = [];

    Array.from(grid.children).forEach((cell) => {
      const item = cell.querySelector("product-grid-item");
      if (!item) return;
      (item.getAttribute("data-availability") === "true" ? available : soldOut)
        .push(cell);
    });
    grid.append(...available, ...soldOut);
  }
  window.sortSoldOut = sortSoldOut;

  /* original listeners that call sortSoldOut() */
  document.addEventListener("DOMContentLoaded", sortSoldOut);
  document.addEventListener("theme:grid:updated", () =>
    requestAnimationFrame(sortSoldOut)
  );
  document.addEventListener("shopify:section:load", () =>
    requestAnimationFrame(sortSoldOut)
  );

  /* =====================================================================
   * 3.  AJAX LOAD‑MORE  +  SOLD‑OUT MANAGEMENT
   * ===================================================================*/

  /* 3‑A.  Global stash for detached sold‑out cells */
  const soldOutStash = [];

  function stashSoldOutCells() {
    const grid = document.querySelector(".collection__content .js-grid");
    if (!grid) return;

    Array.from(grid.children).forEach((cell) => {
      if (
        cell.querySelector("product-grid-item[data-availability='false']") &&
        !cell.dataset.stashed
      ) {
        cell.dataset.stashed = "true";
        soldOutStash.push(cell);
        grid.removeChild(cell); // tidy DOM & stop premature lazy‑loading
      }
    });
  }

  /* 3‑B.  Force‑unveil helper for images + remove shimmer */
  function unveilImages(scope) {
    // 1. Remove shimmer overlays FIRST so they don't block pointer events
    scope.querySelectorAll(".loading-shimmer").forEach((el) => {
      el.classList.remove("loading-shimmer");
    });

    // 2. Handle every <img> element
    scope.querySelectorAll("img").forEach((img) => {
      // Drop the lazy attribute so browser/lazysizes treats it like visible
      img.removeAttribute("loading");

      // Lazysizes present? great – ask it to unveil immediately.
      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(img);
      } else {
        // Fallback: nudge the browser by resetting src
        const src = img.currentSrc || img.src;
        img.src = "";
        img.src = src;
      }
    });
  }

  /* 3‑C.  Reveal sold‑out cells once LAST page is reached */
  function revealSoldOutCells() {
    if (!soldOutStash.length) return;
    const grid = document.querySelector(".collection__content .js-grid");
    if (!grid) return;

    grid.append(...soldOutStash);

    // unveil images *and* strip shimmers inside these cells
    soldOutStash.forEach(unveilImages);

    soldOutStash.length = 0; // clear the stash
    sortSoldOut();
  }

  /* 3‑D.  Button loading‑dots helpers */
  function startLoading(btn) {
    btn.dataset.origText = btn.textContent.trim();
    btn.textContent = "Loading";
    let dots = 0;
    btn._interval = setInterval(() => {
      dots = (dots + 1) % 4;
      btn.textContent = "Loading" + ".".repeat(dots);
    }, 300);
  }
  function stopLoading(btn) {
    clearInterval(btn._interval);
    btn.textContent = btn.dataset.origText || "Load More";
  }

  /* 3‑E.  Fetch next page & inject */
  function appendNextPage(btn) {
    const next = btn.dataset.url;
    if (!next) return;

    startLoading(btn);

    fetch(next)
      .then((r) => r.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;

        const incomingGrid = temp.querySelector(
          ".collection__content .js-grid"
        );
        const currentGrid = document.querySelector(
          ".collection__content .js-grid"
        );
        if (incomingGrid && currentGrid) {
          currentGrid.append(...Array.from(incomingGrid.children));
        }

        /* Update / remove the button */
        const newBtn = temp.querySelector("[data-load-more]");
        if (newBtn && newBtn.dataset.url) {
          btn.dataset.url = newBtn.dataset.url; // more pages remain
        } else {
          btn.remove(); // last page reached
        }

        stopLoading(btn);

        // After new markup is in DOM, update state & ensure images show
        updateSoldOutState();
        unveilImages(document);
      })
      .catch((err) => {
        console.error(err);
        stopLoading(btn);
      });
  }

  /* delegated click for any Load‑More button */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-load-more]");
    if (!btn) return;
    e.preventDefault();
    appendNextPage(btn);
  });

  /* 3‑F.  Shared state updater (called from theme life‑cycle events) */
  function updateSoldOutState() {
    if (document.querySelector("[data-load-more]")) {
      stashSoldOutCells();
    } else {
      revealSoldOutCells();
    }

    // remove any leftover shimmer overlays caused by other scripts
    unveilImages(document);
  }

  document.addEventListener("DOMContentLoaded", updateSoldOutState);
  document.addEventListener("theme:grid:updated", updateSoldOutState);
  document.addEventListener("shopify:section:load", updateSoldOutState);

  // initial run
  updateSoldOutState();
})();
